
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiClearPolartwilightColour as ObiClearPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-clear-polartwilight-colour.js';
 
 
 

 
 export const ObiClearPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-clear-polartwilight-colour',
   elementClass: ObiClearPolartwilightColourElement,
   events: {
     
   }
  });
 
 